import { json } from "@sveltejs/kit";
import { exec } from "child_process";
import { promisify } from "util";
const execAsync = promisify(exec);
const POST = async ({ request }) => {
  try {
    const { path } = await request.json();
    if (!path) {
      return json({ error: "Path is required" }, { status: 400 });
    }
    await execAsync(`git checkout -- "${path}"`);
    return json({ success: true });
  } catch (error) {
    console.error("Git discard error:", error);
    return json({
      error: "Failed to discard changes",
      message: error.message || "Unknown error"
    }, { status: 500 });
  }
};
export {
  POST
};
